import React, { useRef, useState } from 'react';
import api from 'constants/api';
import AxiosPageReadyWrapper from '../AxiosPageReadyWrapper';
import AchievementsWaiting from './AchievementsWaiting';
import useCountingRetry from './useCountingRetry';

const useAchievementsRequest = ({ isCounting, onData }) => {
  const pageReady = useRef();
  const [hasFailed, setHasFailed] = useState(false);
  const retry = useCountingRetry({ isCounting, pageReady });
  const onResponse = (response) => {
    onData(response);
    setHasFailed(false);
    retry.finishRequest();
  };
  const onError = () => {
    setHasFailed(true);
    retry.finishRequest();
  };
  return { ...retry, pageReady, hasFailed, onResponse, onError };
};

const AchievementRequest = ({ query, request, isWaiting, children }) => (
  <AxiosPageReadyWrapper
    ref={request.pageReady}
    method="post"
    url={api.graphql()}
    postBody={{ query }}
    onData={request.onResponse}
    customErrorHandler={request.onError}
    renderCustomLoader={() => (isWaiting ? <React.Fragment /> : null)}>
    {children}
  </AxiosPageReadyWrapper>
);

const AchievementsPageReady = ({ query, isCounting, onData, children }) => {
  const request = useAchievementsRequest({ isCounting, onData });
  const isWaiting = isCounting && !request.hasFailed;
  return (
    <React.Fragment>
      {isWaiting ? (
        <AchievementsWaiting isExhausted={request.isExhausted} />
      ) : null}
      <AchievementRequest query={query} request={request} isWaiting={isWaiting}>
        {children}
      </AchievementRequest>
    </React.Fragment>
  );
};

export default AchievementsPageReady;
